<template>
	<div class="auth-container">
		<div class="auth-form-container">
			<router-view />
		</div>
		<div class="auth-logo-container">
			<div class="lang-selector">
				<a href="#" @click.prevent="changeLanguage('uk')" :class="{'lang-item': true, 'active': isLang('uk')}">Укр</a>
				<a href="#" @click.prevent="changeLanguage('ru')" :class="{'lang-item': true, 'active': isLang('ru')}">Рус</a>
				<a href="#" @click.prevent="changeLanguage('en')" :class="{'lang-item': true, 'active': isLang('en')}">Eng</a>
			</div>
			
			<div class="logo">
				<img src="../../assets/images/logo.svg" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: "Auth",

    computed: {
        ...mapState(['language', 'translations']),
    },

	methods: {
		changeLanguage(lang) {
			this.$store.commit('changeLang', lang);
			this.$i18n.locale = lang;
			this.$i18n.setLocaleMessage(lang, this.translations);

            setI18NLanguage();
		},

		isLang(lang) {
			return this.language === lang;
		},
	}
};
</script>

<style lang="scss">
.auth-container	{
	width: 100%;
	height: 100%;
	display: flex;

	@media (max-width: 768px) {
		flex-direction: column-reverse;
		height: auto;
		margin: auto;
	}

	.auth-form-container {
		width: 70%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
    	background: #fff;

		@media (max-width: 768px) {
			width: 100%;
			align-items: flex-start;
			height: auto
		}

		form {
			width: 100%;
			padding: 0 30%;
			display: flex;
			flex-direction: column;

			@media (max-width: 768px) {
				padding: 25px;
				padding-top: 0;
			}

			.form-group {
				display: flex;
				flex-direction: column;
				margin-bottom: 10px;

				label {
					margin-bottom: 0;
				}
			}

			.password-group {
				display: flex;
				justify-content: space-between;
				align-items: center;
			}

			.btn-restore {
				text-align: right;
				padding: 0;
				font-size: 12px;
			}

			.btn-social {
				margin: 2px 0;
			}
		}
	}

	.auth-logo-container {
		width: 30%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
    	background: #F1F3F9;

		@media (max-width: 768px) {
			width: 100%;
			height: auto;
			flex-direction: column-reverse;
			padding: 0;
			padding-top: 15px;
			background: #fff;
		}

		.logo {
			position: relative;
			margin-bottom: auto;

			&:after {
				content: "alpha";
				position: absolute;
				top: 0;
				right: 0;
				color: #1c1c1c;
				font-size: 13px;
			}
		}

		.lang-selector {
			padding: 20px 0;
			margin-bottom: auto;

			.lang-item {
				font-size: 13px;
				display: inline-block;
				width: 40px;
				height: 24px;
				text-align: center;
				line-height: 24px;
				border-radius: 6px;
				transition: all .3s ease-in;
				cursor: pointer;
				text-decoration: none;
				color: #000;
				margin: 0 5px;

				&:hover {
					background: #336ebd;
					color: #fff;
				}

				&.active {
					background: #f59c25;
					color: #fff;
				}
			}
		}

	}
}

.btn-google {
	background:#de5e45 url('../../assets/images/google.png') no-repeat left 12px center!important;
	border-color: #de5e45!important;
	display: flex!important;
	align-items: center;
	justify-content: center;
	color: #fff!important;
	font-size: 14px!important;
}

.btn-facebook {
	background:#3b5998 url('../../assets/images/facebook.png') no-repeat left 12px center!important;
	border-color: #3b5998!important;
	display: flex!important;
	align-items: center;
	justify-content: center;
	color: #fff!important;
	font-size: 14px!important;
}

.btn-apple {
	background:#333 url('../../assets/images/apple-id.svg') no-repeat left 12px center!important;
	border-color: #333!important;
	display: flex!important;
	align-items: center;
	justify-content: center;
	color: #fff!important;
	font-size: 14px!important;
}
</style>
